import { render, staticRenderFns } from "./successPage.vue?vue&type=template&id=4067fe33&scoped=true"
import script from "./successPage.vue?vue&type=script&lang=js"
export * from "./successPage.vue?vue&type=script&lang=js"
import style0 from "./successPage.vue?vue&type=style&index=0&id=4067fe33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4067fe33",
  null
  
)

export default component.exports